/**
 * 数据表格「流程编辑校验」配置注册表（按 gridKey）。
 * 单条审核可从表格 props 取配置；注册表作 gridKey 回查兜底。
 */
export type FlowEditCheckTableConfig = {
  checkFlowEditStatus?: boolean | string | number;
  flowBusIdField?: string;
  key?: string;
};

const registry = new Map<string, FlowEditTableConfigSnapshot>();

type FlowEditTableConfigSnapshot = FlowEditCheckTableConfig & { key: string };

function isEnabled(v: any): boolean {
  return v === true || v === 'true' || v === 1 || v === '1';
}

export function registerFlowEditCheckConfig(gridKey: string, tableProps: any) {
  const key = String(gridKey || tableProps?.key || '').trim();
  if (!key) return;
  if (!isEnabled(tableProps?.checkFlowEditStatus)) {
    registry.delete(key);
    return;
  }
  registry.set(key, {
    key,
    checkFlowEditStatus: tableProps.checkFlowEditStatus,
    flowBusIdField: tableProps.flowBusIdField,
  });
}

export function unregisterFlowEditCheckConfig(gridKey: string) {
  const key = String(gridKey || '').trim();
  if (key) registry.delete(key);
}

export function getFlowEditCheckConfig(gridKey: string): FlowEditTableConfigSnapshot | null {
  const key = String(gridKey || '').trim();
  if (!key) return null;
  return registry.get(key) || null;
}

export function isFlowEditCheckEnabledOnTable(tableProps: any): boolean {
  return isEnabled(tableProps?.checkFlowEditStatus);
}

export function isFlowAuditNodeBtn(btnItem: any): boolean {
  if (!btnItem) return false;
  const v = btnItem.isFlowAuditNode;
  return v === true || v === 'true' || v === 1 || v === '1';
}
